import { render, staticRenderFns } from "./cModalMedicFrequency.vue?vue&type=template&id=bc2e74d0&scoped=true"
import script from "./cModalMedicFrequency.vue?vue&type=script&lang=js"
export * from "./cModalMedicFrequency.vue?vue&type=script&lang=js"
import style0 from "./cModalMedicFrequency.vue?vue&type=style&index=0&id=bc2e74d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2e74d0",
  null
  
)

export default component.exports